import { Box, CircularProgress, Typography } from '@mui/material'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { itemsActions } from 'src/ducks/actions'
import { getApplianceTypes, getEstimate } from 'src/ducks/selectors'
import { ProductTypes } from 'src/ducks/types'
import styles from './styles.module.scss'

type Props = {
    imageBase64: string
    handleSuccess: () => void
}

const Source7Modal = ({ imageBase64, handleSuccess }: Props) => {
    const applianceTypes = useSelector(getApplianceTypes())
    const estimate = useSelector(getEstimate())
    const [loading, setLoading] = useState(false)

    const dispatch = useDispatch()

    const handleSelectApplianceType = (applianceType: ProductTypes) => {
        setLoading(true)
        dispatch(itemsActions.scanApplianceTag({
            images: [{
                content: imageBase64.replace('data:image/jpeg;base64,', '').replace('data:image/png;base64,', '').replace('data:image/jpg;base64,', ''),
                description: 'Label Image',
                read_label: true
            }],
            product_type_id: applianceType.product_type_id,
            propertyId: estimate?.properties?.property?.id || '',
            property_uid: null
        }, (succ, scanLabelData) => {
            if (succ) {
                dispatch(itemsActions.confirmApplianceTag({
                    applianceId: scanLabelData?.appliance_uid || '',
                    brand_id: scanLabelData?.images[0].vision_data?.brand_id || 0,
                    brand_name: scanLabelData?.images[0].vision_data?.brand_name || '',
                    propertyId: estimate?.properties?.property?.id || '',
                    model_number: scanLabelData?.images[0].vision_data?.model_number || '',
                    productTypeId: applianceType.product_type_id,
                    serial_number: scanLabelData?.images[0].vision_data?.serial_number || '',
                    property_uid: scanLabelData?.property_uid || '',
                }, (succ, confirmApplianceTagData) => {
                    if (succ) {
                        handleSuccess()
                        toast.success('Appliance added successfully')
                    } else {
                        handleSuccess()
                    }
                }))
            }

        }))
    }

    return (
        <Box className={styles.container}>
            {loading ? <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', flexDirection: 'column', gap: '12px' }}>
                <CircularProgress size={50} />
                <Typography variant='h6'>Uploading to Source7...</Typography>
            </Box> : <Box>
                <Typography variant='h6'>Select the Appliance Type</Typography>
                <Box className={styles.applianceTypes}>
                    {applianceTypes && applianceTypes.length > 0 ? applianceTypes?.map((applianceType) => (
                        <Box onClick={() => handleSelectApplianceType(applianceType)} key={applianceType.product_type_id} className={styles.applianceType}>
                            <Typography variant='body1'>{applianceType.product_type_name}</Typography>
                        </Box>
                    )) : <Typography variant='h6'>No appliance types found</Typography>}
                </Box>
            </Box>}
        </Box>
    )
}

export default Source7Modal